module.exports = __webpack_public_path__ + "static/media/Stroke-7.cf8cf4ff.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/stroke7/fonts/Stroke-7.ttf?f72xkr
// module id = 779
// module chunks = 0